export default "__VITE_ASSET__D$akkLE2__"